import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { onMounted, onBeforeUnmount } from 'vue';

gsap.registerPlugin(ScrollTrigger);

export function useLockScrollServiceAbout() {
  onMounted(() => {
       // เช็คขนาดหน้าจอก่อนทำงาน
       if (window.innerWidth < 1200) {
        return; // ถ้าหน้าจอต่ำกว่า 1200px ไม่ต้องเรียกใช้ฟังก์ชัน
      }
    initialiseApp();
  });

  onBeforeUnmount(() => {
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });

  function initialiseApp() {
    initialiseGSAPScrollTriggerPinningHorizontal();
  }

  function initialiseGSAPScrollTriggerPinningHorizontal() {
    const sectionPin = document.querySelector('#section_pin');
    const sectionToPin = document.querySelector('.section-lock');

    if (!sectionPin || !sectionToPin) return;

    const cards = sectionPin.querySelectorAll('.service-about__list');
    
    // เช็คจำนวน card
    if (cards.length <= 3) {
      // console.log('Less than or equal to 4 cards, skipping scroll pinning.');
      return;
    }

    setTimeout(() => {
      const cardWidth = cards[0].offsetWidth;
      const gap = 24; // gap ระหว่าง cards (ตามที่กำหนดใน CSS)
      const totalScroll = (cards.length - 3) * (cardWidth + gap); // ลบ 3 cards สุดท้าย

      // กำหนดค่าของ start ตามขนาดหน้าจอ
      const startValue = window.innerWidth < 1400 ? 'top 100px' : 'top 100px';

      const containerAnimation = gsap.to(sectionPin, {
        scrollTrigger: {
          trigger: '.section-lock',
          pin: true,
          pinSpacing: true,
          start: startValue, // ใช้ start ที่กำหนดตามเงื่อนไข
          end: () => `+=${totalScroll}`,
          scrub: 1,
          anticipatePin: 1,
          markers: false,
          // onEnter: () => {
          //   console.log('Entered service section');
          // },
          // onLeave: () => {
          //   console.log('Left service section');
          // }
        },
        x: -totalScroll,
        ease: 'none',
      });

      const imageWrappers = sectionPin.querySelectorAll('.service__list');
      imageWrappers.forEach((imageWrapper) => {
        gsap.to(imageWrapper, {
          scrollTrigger: {
            trigger: imageWrapper,
            start: 'left center',
            end: 'right center',
            containerAnimation: containerAnimation,
          },
        });
      });
    }, 100);

    window.addEventListener('resize', () => {
      ScrollTrigger.refresh();
    });
  }
}
